import { t } from '@lingui/core/macro';
import { QuoteRequestLineItemStatus } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export function formatQuoteRequestLineItemStatus(
    status: QuoteRequestLineItemStatus | null,
    { perspective }: { perspective: 'sender' | 'receiver' },
): string {
    if (status === null) {
        return t`No link`;
    }
    // This is the perspective of the EMS
    if (perspective === 'sender') {
        switch (status) {
            case QuoteRequestLineItemStatus.Received:
                return t`Received`;
            case QuoteRequestLineItemStatus.Sent:
                return t`Sent`;
            case QuoteRequestLineItemStatus.Overdue:
                return t`Overdue`;
            case QuoteRequestLineItemStatus.Discarded:
                return t`Discarded`;
            case QuoteRequestLineItemStatus.NotSent:
                return t`Draft`;
            case QuoteRequestLineItemStatus.Awarded:
                return t`Awarded`;
            case QuoteRequestLineItemStatus.NoBid:
                return t`No bid`;
            case QuoteRequestLineItemStatus.UnsolicitedOffer:
                return t`Unsolicited offer`;
        }
    }

    // This is the perspective of the supplier portal user
    if (perspective === 'receiver') {
        switch (status) {
            case QuoteRequestLineItemStatus.Received:
                return t`Submitted`;
            case QuoteRequestLineItemStatus.Sent:
                return t`Not submitted`;
            case QuoteRequestLineItemStatus.Overdue:
                return t`Overdue`;
            case QuoteRequestLineItemStatus.Discarded:
                return t`Discarded`;
            case QuoteRequestLineItemStatus.NotSent:
                return t`Draft`;
            case QuoteRequestLineItemStatus.Awarded:
                return t`Awarded`;
            case QuoteRequestLineItemStatus.NoBid:
                return t`No bid`;
            case QuoteRequestLineItemStatus.UnsolicitedOffer:
                return t`Unsolicited offer`;
        }
    }

    assertUnreachable(perspective);
}
